//
// Copyright (c) 2011-2016 by Curalate, Inc.
//

(function() {
    'use strict';

    var DEVICES_BASE = '/mobile-devices';

    angular.module('curalate').service('MobileDeviceSettings', [
        '$http',
        'PromiseService',
        'RestBaseUrl',
        function(
            $http,
            PromiseService,
            RestBaseUrl
        ) {
            this.revokeToken = function(deviceId) {
                return PromiseService.processHttpResponse($http.delete(RestBaseUrl + DEVICES_BASE + '/' + deviceId));
            };

            this.getMobileDevices = function() {
                return PromiseService.processHttpResponse($http.get(RestBaseUrl + DEVICES_BASE));
            };
        }
    ]);
})();
